import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';

import ps from '../../static/images/ps-logo.png';
import idayat from '../../static/images/digital-art/Idayat.jpg';
import justin from '../../static/images/digital-art/Justin.jpg';
import kb from '../../static/images/digital-art/kb_art.jpg';
import mother from '../../static/images/digital-art/mother.jpg';
import sandra from '../../static/images/digital-art/Sandra-personal.jpg';
import stephMum from '../../static/images/digital-art/Stephanie_Ada.jpg';
import tao from '../../static/images/digital-art/tao.jpg';
import tonye from '../../static/images/digital-art/tonye_art.jpg';
import yomi from '../../static/images/digital-art/Yomi_Adisa_art.jpg';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        width: 500,
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
    },
    titleBar: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.4) 0%, ' +
            'rgba(0,0,0,0.1) 70%, rgba(0,0,0,0) 100%)',
    },
    icon: {
        color: 'white',
    },
}));

const tileData = [
    {
        img: mother,
        title: 'Mother',
        author: 'author',
        featured: true,
    },
    {
        img: sandra,
        title: 'Sandra',
        author: 'author',
    },
    {
        img: tonye,
        title: 'Tonye',
        author: 'author',
    },
    {
        img: tao,
        title: 'Tao',
        author: 'author',
        featured: true,
    },
    {
        img: stephMum,
        title: 'Stephs Mum',
        author: 'author',
    },
    {
        img: justin,
        title: 'Justin',
        author: 'author',
    },
    {
        img: idayat,
        title: 'Idayat',
        author: 'author',
    },
    {
        img: kb,
        title: 'Kabiru',
        author: 'author',
    },
    {
        img: yomi,
        title: 'Yomi',
        author: 'author',
        featured: true,
    },
    
];

export default function DigitalArt() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <GridList cellHeight={200} spacing={3} className={classes.gridList} col={3}>
                {tileData.map((tile) => (
                    <GridListTile key={tile.img} cols={tile.featured ? 2 : 1} rows={tile.featured ? 2 : 1}>
                        <img src={tile.img} alt={tile.title} />
                            <GridListTileBar
                                titlePosition="bottom"
                                actionIcon={
                                    <>
                                        <IconButton>
                                            <img src={ps} width="25px" alt="Adobe Photoshop" />
                                        </IconButton>
                                    </>
                                }
                                actionPosition="left"
                                className={classes.titleBar}
                            />
                    </GridListTile>

                ))}
            </GridList>
        </div>
    );
}